module.exports = "/_next/static/images/Hero-xs@2x-c775b5d214e3a05a1bdf85cf640962ea.webp";